import i18next from "i18next";
import { camelCase } from "lodash";

export const t = (name, options) => {
  const key = name.split(".").map(camelCase).join(".");
  return i18next.t(key, options);
};
